import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import axios from 'axios'
import QuickStatRepsTable from './QuickStatRepsTable';
import { handleAxiosError, getAPIUrl } from '../AppUtils';

const styles = theme => ({
    page: {
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 50,
        paddingRight: 50,
        minHeight: 300,
    }
});

function QuickStatRepsPage(props) {
    const { classes, adminView } = props;
    const source = axios.CancelToken.source();
    const [reports, setReports] = useState(undefined);
    const [aggregates, setAggregates] = useState([]);

    //mount, unmount
    useEffect(() => {
        getReports();
        getAggregates();
        return () => {source.cancel("unmount");}
    }, []);
    function getAggregates(){
        axios.get(getAPIUrl()+'/quickStatRepAggregates',{cancelToken: source.token})
        .then(response => {
            setAggregates(response.data);
        })
        .catch(error=>handleAxiosError(error));
    }
    function getReports(){
        if(adminView){
            axios.get(getAPIUrl()+'/quickStatReps',{cancelToken: source.token})
            .then(response => {
                setReports(response.data);
            })
            .catch(error=>handleAxiosError(error));
        }
        else{
            axios.get(getAPIUrl()+'/userQuickStatReps',{cancelToken: source.token})
            .then(response => {
                setReports(response.data);
            })
            .catch(error=>handleAxiosError(error));
        }
    }
    return (
        <div className={classes.page}>
            <QuickStatRepsTable
                reports={reports}
                adminView={adminView}
                identifierColumns={aggregates}
            />
        </div>
    );
}

export default withStyles(styles)(QuickStatRepsPage);